<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;" matTooltip="{{this.translate.data['TOOLTIPVIEWTENANTINFO'] | translate}}" [routerLink]="routerLinkEditTenant">Mandanteninformationen</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;" matTooltip="{{this.translate.data['TOOLTIPDELETETENANT'] | translate}}" (click)="deleteTenant()">Löschen</button>
</a>
